export default __webpack_public_path__ + "785fccb9d777af3d43455996bb4c5441.png";